import $ from 'jquery';

	$( document ).ready( function () {
		const customer_number_input = $( '.customer-number' );

		customer_number_input.on( 'change', function ( e ) {
			const psh_number = $( e.target ).data( 'psh-number' );
			const customer_item_number = $( e.target ).val();

			$.ajax( {
				type: "POST",
				url: psh_vars.rest_route.psh_customer_number,
				data: {
					psh_number: psh_number,
					customer_item_number: customer_item_number
				},
				success: function () {
					$( '.specification--customer-number' ).addClass( 'specification--success' ).removeClass( 'specification--error' );
					$( '.specification-value__edit-icon' ).hide();
				},
				error: function () {
					$( '.specification--customer-number' ).addClass( 'specification--error' ).removeClass( 'specification--success' );
					$( '.specification-value__edit-icon' ).show();
				}
			} );
		} );
	} );
